import { KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'

export default {
    name: 'kendo-menu-item',
    render (h) {
        return h('span',this.$slots.default)
    },
    mixins: [
        KendoSharedMethods
    ],
    props:{
        text: String,
        cssClass: String,
        url: String,
        attr: Object,
        encoded: Boolean,
        content: String,
        contentAttr: Object,
        imageAttr: Object,
        imageUrl: String,
        items: Array,
        spriteCssClass: String,
        select: Function
    },
    mounted() {
        this._resolveInnerChildren()
    },
    methods: {
        _resolveInnerChildren() {
            if(!this.$options.propsData['items'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-menu-item')
                this.subitems = items
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/KendoMenuItem.js